import { useState } from 'react';
import { useMutation } from '@apollo/client';
import DELETE_POST from '../graphql/deletePost';

export const useDeletePost = ({ postId, onDeleteSuccess, onDeleteError }) => {
  const [processing, setProcessing] = useState(false);
  const [result, setResult] = useState();

  const [deletePost] = useMutation(DELETE_POST, {
    onCompleted: data => {
      if (data?.deletePost?.success) {
        setProcessing(false);
        setResult(data);
        onDeleteSuccess();
      }
      if (data?.deletePost.userFriendlyMessage) {
        setProcessing(false);
        setResult(data);
        onDeleteError(data?.deletePost.userFriendlyMessage);
      }
    },
    onError: err => {
      setProcessing(false);
      onDeleteError(err);
    },
  });

  return {
    processing,
    result,
    deletePost: () => {
      setProcessing(true);
      deletePost({
        variables: { input: { postId } },
      }).catch(e => console.error(e));
    },
  };
};
